var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevation-0"},[(this.$slots.title)?_c('v-card-title',[_c('v-icon',[_vm._v("info")]),_vm._t("title")],2):_vm._e(),_c('v-card-text',{class:this.$slots.title ? 'under-title' : ''},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }